import { DELAY } from 'src/app/core/utils/constants';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { delay } from 'rxjs/operators';

/**
 * Métodos para realizar peticiones http.
 * A cada uno de los métodos http (GET, POST, DELETE...) le corresponden dos métodos de este servicio: uno para operar con promesas y otro con observables
 */
@Injectable({
  providedIn: 'root'
})
export class RepositoryService {

  constructor(private http: HttpClient) { }

  public doGet(url: string): Observable<any> {
    return this.http.get(url).pipe(delay(DELAY));
  }

  public doPut(url: string): Observable<any> {
    return this.http.put(url, { responseType: 'text'}).pipe(delay(DELAY));
  }

  public doGetIp(url: string, header?: HttpHeaders): Observable<any> {
    const headers = (header == undefined || header == null) ? new HttpHeaders() : header;
    headers.set('Access-Control-Allow-Credentials', 'true')
    .set('Access-Control-Allow-Methods', 'GET, POST, OPTIONS, PUT, PATCH, DELETE')
    .set('Access-Control-Allow-Origin', '*')
    .set('Access-Control-Allow-Headers', 'X-Requested-With,content-type');
    return this.http.get(url, {headers: headers}).pipe(delay(DELAY));
  }

  public doPost(url: string, body: any, header?: HttpHeaders): Observable<any> {
    const json = JSON.stringify(body);
    const headers = (header == undefined || header == null) ? new HttpHeaders().set('Content-Type', 'application/json;charset=UTF-8') : header;
    return this.http.post(url, json, {headers: headers});
  }

  /**
   * @description
   * Obtiene un parameters por su id
   */
  public findByCode(url: string, code: string): Observable<any> {
    let codevalue: string = (code !== undefined && code !== null ? code + "" : "");
    return this.http.get(url + "/" + codevalue).pipe(delay(DELAY));
  }

  /**
   * Se hace un get y se devuelve una promesa con el resultado
   * @param url Url de la petición
   */
  public doGetProm(url: string): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      this.http.get(url)
        .toPromise()
        .then(
          (x: any) => {
            console.log("Respuesta en repository get map");
            console.log(x);
            resolve(x);
          },
          (error) => {
            console.log("Respuesta en repository get error");
            console.log(error);
            reject(error);
          }
        ).catch(reject);
    });
    return promise;
  }
}
